import { createSlice } from '@reduxjs/toolkit';

const FJPublishHistorySlice = createSlice({
    name: 'FJPublishHistorySlice',
    initialState: {
        isShow: false,
        history: [],
    },
    reducers: {
        setIsShow: (state, action) => {
            state.isShow = action.payload;
        },
        setHistory: (state, action) => {
            state.history = action.payload;
        },
    },
});

export default FJPublishHistorySlice;
